package com.eladfinish.bible.contest.screens.randomVerse.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp

@Composable
internal fun BookWidget(
    title: String,
    isMikud: Boolean,
    active: Boolean,
    onClick: (String) -> Unit,
) {
    CompositionLocalProvider(LocalLayoutDirection provides LayoutDirection.Rtl) {
        val colorCorners = Color(0xFFD4A010)
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(60.dp)
                .clickable {
                    when {
                        active -> onClick(title)
                    }
                }
                .border(width = 1.dp, color = colorCorners, shape = RoundedCornerShape(10.dp))
        ) {
            val textColor =
                when (active) {
                    true -> Color(0xFF090000)
                    false -> Color(0xFFB2A8A0)
                }
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
                    .padding(1.dp)
                    .background(color = Color.Transparent, shape = RoundedCornerShape(10.dp)),
            ) {
                AutoResizeText(
                    text = title.uppercase(),
                    color = textColor,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    hasUnderline = isMikud,
                    modifier = Modifier
                        .padding(start = 1.dp, end = 1.dp, top = 15.dp, bottom = 10.dp)
                        .heightIn(40.dp)
                        .fillMaxWidth()
                        .align(Alignment.Center),
                )
            }
        }
    }
}
